import * as _ from 'lodash';
import moment from 'moment';

export function getCurrentSeason(): Season {
    const currentMonth = moment().month();
    const currentYear = moment().year();

    return {
        key: currentMonth < 4 || currentMonth > 9 ? SeasonKey.SpringSummer : SeasonKey.FallWinter,
        year: currentMonth > 9 ? _.toString(currentYear + 1) : _.toString(currentYear)
    };
}

function getUpcomingSeason(season?: Season): Season {
    const baseSeason = !season || season.key === SeasonKey.NOS || !season.year ? getCurrentSeason() : season;
    const seasonYear = _.parseInt(baseSeason.year);
    const isWinterSeason = baseSeason.key === SeasonKey.FallWinter;

    return {
        key: isWinterSeason ? SeasonKey.SpringSummer : SeasonKey.FallWinter,
        year: isWinterSeason ? _.toString(seasonYear + 1) : _.toString(seasonYear)
    };
}

export function getUpcomingSeasons(amountOfUpcomingSeasons: number): Season[] {
    return _.reduce(
        new Array(amountOfUpcomingSeasons),
        (seasons) => [...seasons, getUpcomingSeason(_.last(seasons))],
        []
    );
}

export function getNosSeason(): Season {
    return { key: SeasonKey.NOS };
}

export interface Season {
    key: SeasonKey;
    year?: string;
}

export enum SeasonKey {
    FallWinter = 'fall_winter',
    SpringSummer = 'spring_summer',
    NOS = 'nos'
}

export const seasonTranslationKeyMap: Record<SeasonKey, string> = {
    [SeasonKey.SpringSummer]: 'SEASON_SPRING_SUMMER',
    [SeasonKey.FallWinter]: 'SEASON_FALL_WINTER',
    [SeasonKey.NOS]: 'NOS'
};
